import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const CommitmentSection = ({ content }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const phaseVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section
      id="commitment"
      className="min-h-screen py-24 bg-white flex items-center"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#003366] mb-4">
            {content.title}
          </h2>
          <div className="w-24 h-1 bg-[#003366] mx-auto rounded-full"></div>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="relative"
        >
          {/* Timeline Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-[#003366] to-[#001f3f] transform md:-translate-x-1/2"></div>

          <div className="space-y-12">
            {content.phases.map((phase, index) => (
              <motion.div
                key={index}
                variants={phaseVariants}
                className="relative pl-16 md:pl-0 md:flex md:items-center"
              >
                {/* Timeline Dot */}
                <div className="absolute left-6 md:left-1/2 w-4 h-4 bg-[#003366] rounded-full border-4 border-white shadow-lg transform md:-translate-x-1/2 z-10"></div>

                {/* Content Card */}
                <div
                  className={`md:w-1/2 ${
                    index % 2 === 0 ? 'md:pr-8 md:text-right' : 'md:ml-auto md:pl-8'
                  }`}
                >
                  <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow">
                    <h3 className={`text-2xl font-bold text-[#003366] mb-4 ${index % 2 === 0 ? 'md:text-right' : ''}`}>
                      {phase.title}
                    </h3>
                    <ul className="space-y-3">
                      {phase.items.map((item, itemIndex) => (
                        <li
                          key={itemIndex}
                          className={`flex items-start space-x-3 ${index % 2 === 0 ? 'md:flex-row-reverse md:space-x-reverse' : ''}`}
                        >
                          <CheckCircle2 className="w-5 h-5 text-[#003366] mt-1 flex-shrink-0" />
                          <span className="text-gray-700 leading-relaxed">
                            {item}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CommitmentSection;

